#import "../fragments/contact-primary-account-fragment.graphql"

query GetContactPrimaryAccount($id: ID!) {
    contact(id: $id) {
        id
        primaryAccount {
            ...ContactPrimaryAccountFragment
        }
    }
}
